import React, { useContext } from "react";
import PropTypes from "prop-types";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import VariantBuilderPanelCollapse from "../variants/VariantBuilderPanelCollapse";

const ElementSettingsEmbedDesign = (props) => {
  const [contextData, builder, setContextData] = useContext(VariantContextData);
  let variant = contextData.objects.variant;
  let element = builder.selected().object;
  let section = variant.sections[element.section_id];

  return (
    <React.Fragment>
      <VariantBuilderPanelCollapse name={`Embed`} open={false}>
        <VariantBuilderSetting
          object={element}
          label="Embed Max Width"
          setting_name="[options][embed-width]"
          setting_type="box_width"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["embed-width"]
              ? element.options["embed-width"]
              : "auto"
          }
          show_reset={true}
          device="desktop"
        />

        <VariantBuilderSetting
          object={section}
          setting_name="[options][embed-width-value]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label={"Embed Max Width"}
          value={
            element.options["embed-width-value"]
              ? element.options["embed-width-value"]
              : undefined
          }
          placeholder={"300"}
          condition={element.options["embed-width"] == "custom"}
          min={0}
          max={2560}
          allow_empty={true}
          show_reset={true}
          range_step={"1"}
          device="desktop"
        />

        <VariantBuilderSetting
          object={element}
          label="Embed Max Width"
          setting_name="[options][embed-width-mobile]"
          setting_type="box_width"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["embed-width-mobile"]
              ? element.options["embed-width-mobile"]
              : undefined
          }
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={section}
          setting_name="[options][embed-width-value-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label={"Embed Max Width"}
          value={element.options["embed-width-value-mobile"]}
          placeholder={element.options["embed-width-value"] || "300"}
          condition={element.options["embed-width-mobile"] == "custom"}
          min={0}
          max={2560}
          allow_empty={true}
          show_reset={true}
          range_step={"1"}
          device="mobile"
        />
      </VariantBuilderPanelCollapse>
    </React.Fragment>
  );
};

export default ElementSettingsEmbedDesign;
